export class CCAttestation {
    public ccAttestationId: number;
    public ccBlockId: number;
    public ccAttestationType: number;
    public appliedToYear: number;
    public credits: number;
    public selfReportedCredits: number;
    public attestationDate: Date;
    public updatedDate: Date;
}

export enum CCAttestationType {
    CME = 1,
    SA = 2,
    PIPFeedback = 3,
    PIPClinical = 4,
    PatientSafety = 7
}